import { Box, Container, Typography, Button, Paper, Chip } from '@mui/material'

export default function Hero() {
  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 12, md: 16 },
        pb: 0,
        px: { xs: 2, sm: 3, lg: 4 },
        overflow: 'hidden',
        position: 'relative',
        background: '#ffffff',
        '&::before': {
          content: '""',
          position: 'fixed',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 0,
          background: 'radial-gradient(at 20% 50%, rgba(220, 38, 38, 0.1) 0%, transparent 50%)',
        },
        '&::after': {
          content: '""',
          position: 'fixed',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 0,
          background: 'radial-gradient(at 80% 50%, rgba(249, 115, 22, 0.1) 0%, transparent 50%)',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Badge */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Chip
            label="✨ Revolução no Atendimento"
            sx={{
              backgroundColor: '#fee2e2',
              color: '#dc2626',
              fontWeight: 600,
              fontSize: '0.95rem',
              height: 'auto',
              py: 1,
              px: 2,
              border: '1px solid #fca5a5',
            }}
          />
        </Box>

        {/* Main Title */}
        <Typography
          component="h1"
          sx={{
            fontSize: { xs: '2.25rem', sm: '3.75rem', md: '4.5rem' },
            fontWeight: 900,
            textAlign: 'center',
            mb: 3,
            lineHeight: 1.1,
          }}
        >
          <Typography component="span" sx={{ display: 'block', color: '#1f2937', mb: 1 }}>
            Gestão de Atendimento
          </Typography>
          <Typography
            component="span"
            sx={{
              display: 'block',
              background: 'linear-gradient(135deg, #dc2626 0%, #f97316 50%, #ec4899 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Inteligente e Rápida
          </Typography>
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            color: '#6b7280',
            fontSize: { xs: '1rem', md: '1.25rem' },
            mb: 6,
            maxWidth: '800px',
            mx: 'auto',
            lineHeight: 1.7,
            fontWeight: 400,
          }}
        >
          Conecte clientes, garçons e cozinha em tempo real. Um simples QR Code na mesa
          transforma a experiência de atendimento no seu restaurante. Rápido, eficiente e sem complicações.
        </Typography>

        {/* CTA Buttons */}
        <Box sx={{ mb: 10, textAlign: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
            }}
          >
            🚀 Comece Agora
          </Button>
        </Box>

        {/* Stats */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 0, maxWidth: '600px', mx: 'auto' }}>
          {[
            { value: '2s', label: 'Tempo de Resposta' },
            { value: '99.9%', label: 'Uptime Garantido' },
          ].map((stat) => (
            <Paper
              key={stat.label}
              elevation={0}
              sx={{
                p: 3,
                textAlign: 'center',
                border: '1px solid #e5e7eb',
                borderRadius: '1rem',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 900,
                  color: '#dc2626',
                  mb: 1,
                }}
              >
                {stat.value}
              </Typography>
              <Typography sx={{ color: '#6b7280', fontWeight: 500 }}>
                {stat.label}
              </Typography>
            </Paper>
          ))}
        </Box>

      </Container>
    </Box>
  )
}
